<template>
  <div class="card p-3">
    <b-row>
      <b-col>
        <label class="titlePage">Alterações</label>
        <fcc-table
          striped
          hover
          :fields="fields"
          :items="logsOrdenado"
          responsive
          :por-page="itemPorPage"
          pagination
        />
      </b-col>
    </b-row>

    <b-row align-h="end">
      <b-col class="mb-3 text-right">
        <fcc-button @click="excluir">Desfazer</fcc-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  props: {
    baseUrlPublicacao: String,
    idoutfase: Number,
    controlePage: Object,
    tpImportacao: Number,
    logs: Array
  },
  data() {
    return {
      itemPorPage: '10',
      fields: [
        { key: 'idimportacao', label: 'ID', sortable: true },
        { key: 'tipogrupo', label: 'Tipo', sortable: true },
        { key: 'situacao', label: 'Situação', sortable: true },
        { key: 'usuario', label: 'Usuário', sortable: true },
        { key: 'dataimportacao', label: 'Data', sortable: true }
      ]
    }
  },
  methods: {
    formatDate(date) {
      const dateAndHour = date.split(' ')
      const dateParts = dateAndHour[0].split('/')
      return new Date(`${dateParts[1]}/${dateParts[0]}/${dateParts[2]} ${dateAndHour[1]}`)
    },
    excluir() {
      this.callConfirm('Deseja realmente desfazer a importação?', '').then((result) => {
        if (result.value) {
          this.$emit('excluir')
        }
      })
    }
  },
  computed: {
    logsOrdenado() {
      return [...this.logs].sort(
        (a, b) => this.formatDate(a.dataimportacao) - this.formatDate(b.dataimportacao)
      )
    }
  }
}
</script>